import { put, takeLatest } from 'redux-saga/effects'
import { prepareWebAuthnRegistration as prepareRegistration } from '../api/prepareWebAuthnRegistration'
import {
  registerWebAuthn,
  prepareWebAuthnRegistrationFailed
} from '../../actions/setupMFAWebAuthn'
import { PREPARE_WEB_AUTHN_REGISTRATION } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* prepareWebAuthnRegistration({ request }) {
  yield executeSaga(
    request,
    null,
    ({ web_authn_registration_data }) =>
      put(
        registerWebAuthn({
          registrationData: web_authn_registration_data
        })
      ),
    error =>
      put(prepareWebAuthnRegistrationFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: prepareRegistration }) {
  yield takeLatest(
    PREPARE_WEB_AUTHN_REGISTRATION,
    prepareWebAuthnRegistration,
    {
      request
    }
  )
}
